import React from "react";
import wikiMedia from "../../assets/images/sponsors/wikimedia.png";
import oneWorld from "../../assets/images/sponsors/one-world.png";
import wikiVersity from "../../assets/images/sponsors/wikiversity.png";
import unitedNations from "../../assets/images/sponsors/united-nations.png";
import bus from "../../assets/images/sponsors/bus.png";

const Sponsors = () => (
  <div className="section-home our-sponsors animate-onscroll fadeIn">
    <div className="container">
      <h2 className="title-style-1">
        Our Sponsors <span className="title-under"></span>
      </h2>

      <ul className="list-unstyled list-sponsors">
        <li>
          {" "}
          <img src={wikiMedia} alt="" />
        </li>
        <li>
          {" "}
          <img src={oneWorld} alt="" />
        </li>
        <li>
          {" "}
          <img src={wikiVersity} alt="" />
        </li>
        <li>
          {" "}
          <img src={unitedNations} alt="" />
        </li>

        <li>
          {" "}
          <img src={bus} alt="" />
        </li>
        <li>
          {" "}
          <img src={wikiMedia} alt="" />
        </li>
        <li>
          {" "}
          <img src={oneWorld} alt="" />
        </li>
        <li>
          {" "}
          <img src={wikiVersity} alt="" />
        </li>
        <li>
          {" "}
          <img src={unitedNations} alt="" />
        </li>
      </ul>
    </div>
  </div>
);

export default Sponsors;
